module.exports = __webpack_public_path__ + "static/media/yoga-flower.28e24dba.jpg";